import React from "react";

const PopularProfessionsSkeleton = () => {
  return (
    <ul className="flex flex-wrap items-center gap-1 mt-0.5">
      {Array.from({ length: 4 }).map((_, index) => (
        <li key={index}>
          <div className="w-20 h-5 bg-gray-300 animate-pulse rounded"></div>
        </li>
      ))}
    </ul>
  );
};

export default PopularProfessionsSkeleton;
